module.exports = __webpack_public_path__ + "static/img/step2.ec0e761.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/howto/step2.png
// module id = K5M2
// module chunks = 1